export const getArchiveSupportsDataRange = mime => {
  if (!mime) return false;
  switch (mime) {
    // -- Documents --
    case 'application/pdf': // pdf
    // TODO keep consistent with view-archive.component.tsx mime types
    // -- Video --
    case 'application/x-troff-msvideo': // avi
    case 'video/avi': // avi
    case 'video/msvideo': // avi
    case 'video/x-msvideo': // avi
    case 'video/mp4': // mp4
    case 'application/mp4': // mp4
    case 'video/mpeg': // mpeg
    case 'video/x-mpeg': // mpeg
    case 'video/ogg': // ogv,ogg
    case 'video/webm': // webm
    // video/x-ms-wmv // wmv
    // video/x-ms-asf // wmv
    // video/3gpp // 3gp
    // video/3gpp2 // 3gp2

    // -- Audio --
    case 'audio/ogg': // oga,ogg
    case 'audio/webm': // weba
    case 'audio/mpeg': // mp3
    case 'audio/mpeg3': // mp3
    case 'audio/x-mpeg-3': // mp3
    case 'audio/wav': // wav
    case 'audio/x-wav':
      // wav
      // audio/3gpp // 3gp
      // audio/3gpp2 // 3gp2
      return true;
    default:
      return false;
  }
};